import(/* webpackMode: "eager", webpackExports: ["default"] */ "E:\\Final Projects Repo\\LocoBuzzWebsite\\locobuzz-website\\app\\(generated)\\diwali-delights-with-locobuzz\\Body.jsx");
